import styled from 'styled-components';

export const SliderWrapper = styled.div`
  position: relative;

  & button {
    position: absolute;
    outline: none;
    border: none;
    background: transparent;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    font-size: 50px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .back-arrow {
    left: 0;
  }

  .forward-arrow {
    right: 0;
  }
`;
